export default "__VITE_ASSET__KJ9aixg7__"